import { render } from "./PolicyContentComp.vue?vue&type=template&id=a1adf23c&scoped=true"
import script from "./PolicyContentComp.vue?vue&type=script&lang=js"
export * from "./PolicyContentComp.vue?vue&type=script&lang=js"

import "./PolicyContentComp.vue?vue&type=style&index=0&id=a1adf23c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1adf23c"]])

export default __exports__